import React, { useEffect, useState } from 'react';
import { folderService } from 'services';

const usePilotClients = (show) => {
    const [pilotClientsData, setPilotClientsData] = useState({});

    const handleApi = async () => {
        try {
            const response = await folderService.pilotClientList();
            setPilotClientsData(response?.data?.data?.pilotClients)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        show && handleApi();
    }, [show]);

    return { pilotClientsData };
}

export default usePilotClients;